module.exports = __webpack_public_path__ + "static/about_us-9c6abb6050e6d8993aa2574eb99bf093.jpg";